import React, { Component } from 'react';
import Teoria from 'teoria';
import {Flow as VF} from 'vexflow';
import './App.css';

const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

const settings = {
  treble: true,
  bass: true,
  tenor: true,
  alto: true,
  major: true,
  'natural minor': true,
  'harmonic minor': true,
  'melodic minor': true,
};

if (window.location.hash.substring(1)) {
  const hash = window.location.hash.substring(1).split(',');
  Object.keys(settings).forEach(s => {
    settings[s] = hash.includes(s);
  });
  if (!settings.treble && !settings.bass && !settings.alto && !settings.tenor) {
    settings.treble = true;
  }
  if (!settings.major && !settings['natural minor'] && !settings['melodic minor'] && !settings['harmonic minor']) {
    settings.major = true;
  }
}

const possibleCleffs = ['treble', 'bass', 'alto', 'tenor'];

const roots = {
  treble: {A: 4, B: 3, C: 4, D: 4, E: 4, F: 4, G: 4},
  bass:   {A: 2, B: 2, C: 3, D: 2, E: 2, F: 2, G: 2},
  alto:   {A: 3, B: 3, C: 3, D: 3, E: 3, F: 3, G: 3},
  tenor:  {A: 2, B: 2, C: 3, D: 3, E: 3, F: 3, G: 3},
};

const keys = {
  major: ['F', 'C', 'G', 'D', 'A', 'E', 'B', 'F#', 'C#', 'Cb', 'Gb', 'Db', 'Ab', 'Eb', 'Bb'],
  minor: ['a', 'e', 'b', 'f#', 'c#', 'g#', 'd#', 'a#', 'ab', 'eb', 'bb', 'f', 'c', 'g', 'd'],
};
keys['natural minor'] = keys.minor;
keys['harmonic minor'] = keys.minor;
keys['melodic minor'] = keys.minor;

const intervals = {
  major:            ['P1', 'M2', 'M3', 'P4', 'P5', 'M6', 'M7', 'P8'],
  'natural minor':  ['P1', 'M2', 'm3', 'P4', 'P5', 'm6', 'm7', 'P8'],
  'harmonic minor': ['P1', 'M2', 'm3', 'P4', 'P5', 'm6', 'M7', 'P8'],
  'melodic minor':  ['P1', 'M2', 'm3', 'P4', 'P5', 'M6', 'M7', 'P8'],
};

let ks, clef, direction, scale, key, root;
let allTheNotes;
let TOS; // play timeouts

function getCount() {
  return null;
}

function getQuestion(i) {
  
  const allCleffs = [];
  possibleCleffs.forEach(c => {
    if (settings[c]) {
      allCleffs.push(c);
    }
  });
  if (settings.alto || settings.tenor) {
    if (settings.bass) {
      allCleffs.push('bass');  
    }
    if (settings.treble) {
      allCleffs.push('treble'); 
    }
  }
  const allScales = [];
  Object.keys(intervals).forEach(s => {
    if (settings[s]) {
      allScales.push(s);
    }
  });
  
  clef = getRandom(allCleffs);
  ks = clef === 'alto' || clef === 'tenor' ? false : Math.random() > 0.5;
  direction = getRandom(['ascending', 'descending', 'ascending']);
  scale = getRandom(allScales);
  key = getRandom(keys[scale]);
  root = roots[clef][key.charAt(0).toUpperCase()];
 
  return (
    <div>
      <p>Using your own manuscript paper, please write out</p>
      <p>
        <strong>{pretty(key)} {scale} {direction}</strong>{' '}
        in <strong>{clef}</strong> clef {' '}
        <strong>{ks ? null : 'without'} using</strong> a key signature.
      </p>
    </div>
  ); 

}

function getAnswer(i) {  
  let ints = scale === 'melodic minor' && direction === 'descending'
    ? intervals['natural minor']
    : intervals[scale];

  const tRoot = Teoria.note(key + root);
  allTheNotes = [];
  ints.map(interval => 
    allTheNotes.push(Teoria.interval(tRoot, interval))
  );
  if (direction === 'descending') {
    allTheNotes = allTheNotes.reverse();
  }

  const renderer = new VF.Renderer(document.getElementById('_vex'), VF.Renderer.Backends.SVG);
  renderer.resize(510, 100);
  const context = renderer.getContext();
  const stave = new VF.Stave(0, 0, 490);
  stave.addClef(clef);
  
  const vfKey = scale === 'major' ? key : key.charAt(0).toUpperCase() + key.substring(1) + 'm';
  
  if (ks) {
    stave.addKeySignature(vfKey);
  }    
  stave.setContext(context).draw();

  const signatureAccidentals = getAccidentals(vfKey).notes;
  const signatureAccidentalsType = getAccidentals(vfKey).type;

  const notes = allTheNotes.map(note => {
    const staveNote = new VF.StaveNote({
      clef: clef, 
      keys: [note.name() + note.accidental().replace('x', '##') + '/' + note.octave()], 
      duration: 'w',
    });
    if (!ks && note.accidental()) {
      staveNote.addAccidental(0, new VF.Accidental(note.accidental().replace('x', '##')));
    }
    if (ks) {
      const noteaccidental = note.accidental();
      const notename = note.name().toUpperCase();
      if (noteaccidental && (!signatureAccidentals.includes(notename) || noteaccidental !== signatureAccidentalsType)) {
        staveNote.addAccidental(0, new VF.Accidental(noteaccidental.replace('x', '##')));
      } else if (signatureAccidentals.includes(notename) && noteaccidental !== signatureAccidentalsType) {
        staveNote.addAccidental(0, new VF.Accidental('n'));
      }
    }
    return staveNote;
  });

  const voice = new VF.Voice({num_beats: 4,  beat_value: 4});
  voice.setStrict(false);
  voice.addTickables(notes);

  const formatter = new VF.Formatter();
  formatter.joinVoices([voice]).format([voice], 380);
  voice.draw(context, stave);
  
  return (
    <div>
      <p style={{margin: 0}}><strong>{pretty(key)} {scale}</strong> {direction}, {ks ? 'with' : 'no'} key signature</p>
      <div className="scale" dangerouslySetInnerHTML={{__html: context.svg.outerHTML}} />
    </div>
  );
}

function getAudio() {
  if (iOS) {
    return [];
  }
  return allTheNotes.map(note => {
    return new Audio('samples/' + getFileNote(note) + '.mp3');
  });
}

const sharpsflats = {
  '#': 'FCGDAEB'.split(''),
  'b': 'BEADGCF'.split(''),
};

function getAccidentals(sig) {
  const v = VF.keySignature(sig);
  if (v.length === 0) {
    return {
      type: null,
      notes: [],
    };
  }
  const acc = v[0].type;
  return {
    type: acc,
    notes: sharpsflats[acc].slice(0, v.length)
  };
}

function getNormalNote(note) {
  if (note.accidentalValue() === 0) { // no sharp, nor flats
    return note.toString().toUpperCase();
  }
  if (note.accidentalValue() === 1) { // sharp
    return note.toString().replace('#', '-').toUpperCase();
  }
  return null;
}

function getFileNote(note) {
  const res = getNormalNote(note) || getNormalNote(note.enharmonics()[0]) || getNormalNote(note.enharmonics()[1]);
  return res
    .replace('E-', 'F')
    .replace('B-1', 'C3')
    .replace('B-2', 'C3')
    .replace('B-3', 'C4')
    .replace('B-4', 'C5')
    .replace('B-5', 'C6');
}

function pretty(n) {
  const note = Teoria.note(n);
  return note.name() + 
    note.accidental()
      .replace('#', '♯')
      .replace(/b/g, '♭')
      .replace('x', '𝄪');
}

function getRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// the actual quiz is done, boring stuff follows...

class App extends Component {
  constructor() {
    super();
    this.state = {
      question: getQuestion(1),
      answer: getAnswer(1),
      total: getCount(),
      i: 1,
      audio: getAudio(),
      pause: false,
      settings: false,
    };
    window.addEventListener('keydown', (e) => {
      // space bar
      if (e.keyCode === 32 || e.charCode === 32) {
        e.preventDefault();
        this.play();
      }
      // p and P
      if (e.keyCode === 112 || e.charCode === 112 || e.keyCode === 80 || e.charCode === 80) {
        e.preventDefault();
        this.play();
      }
      // right arrow
      if (e.keyCode === 39 || e.charCode === 39) {
        e.preventDefault();
        this.nextQuestion();
      }
      // n and N
      if (e.keyCode === 110 || e.charCode === 110 || e.keyCode === 78 || e.charCode === 78) {
        e.preventDefault();
        this.nextQuestion();
      }
    });
  }
  
  nextQuestion() {
    this.pause()
    this.setState({
      question: getQuestion(this.state.i + 1),
      answer: getAnswer(this.state.i + 1),
      i: this.state.i + 1,
      audio: getAudio(),
    });
  }
 
  pause() {
    this.state.audio.forEach(au => {
      au.pause();
      au.currentTime = 0;
    });
    this.setState({pause: true});
    TOS && TOS.forEach(to => clearTimeout(to));
  }
   
  play() {
    this.pause();
    this.setState({pause: false});
    if (iOS) {
      return;
    }
    TOS = this.state.audio.map((au, idx) => {
      return setTimeout(() => {
        if (this.state.pause) return;
        au.play();
      }, 800 * idx);
    });
  }
  
  toggleSettings() {
    if (this.state.settings) {
      this.nextQuestion();
    }
    this.setState({settings: !this.state.settings});
  }
  
  render() {
    return (
      <div>
        <div className="settings">
          <div className="settingsLink" onClick={this.toggleSettings.bind(this)}>⚙ Customize</div>
          {this.state.settings 
          ? <div>
              <Settings init={settings} /> 
              <button className="settingsButton" onClick={e => {
                this.toggleSettings();
                this.nextQuestion();
              }}>done</button>
            </div>
          : null
          }
        </div>
        {
          this.state.total 
            ? <Count i={this.state.i} total={this.state.total} />
            : null
        }
        <Flashcard
          id={this.state.i}
          question={this.state.question}
          answer={this.state.answer}
        />
        {iOS 
          ? null
          : <button 
              className="playButton" 
              onClick={this.play.bind(this)}>▶</button>
        }
        {' '}
        {
          (this.state.total && this.state.i >= this.state.total)
            ? null
            : <button 
                className="nextButton" 
                onClick={this.nextQuestion.bind(this)}>
                next...
              </button>
        }
      </div>
    );
  }
}

class Flashcard extends Component {

  constructor(props) {
    super();
    this.state = {
      reveal: false,
      id: props.id,
    };
    window.addEventListener('keydown', (e) => {
      // arrows
      if (e.keyCode === 38 || e.charCode === 38 || e.keyCode === 40 || e.charCode === 40) {
        this.flip();
      }
      // f and F
      if (e.keyCode === 102 || e.charCode === 102 || e.keyCode === 70 || e.charCode === 70) {
        this.flip();
      }
    });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.id !== state.id) {
      return {
        reveal: false,
        id: props.id,
      };
    }
    return null;
  }

  flip() {
    this.setState({
      reveal: !this.state.reveal,
    });
  }

  render() {
    const className = "card flip-container" + (this.state.reveal ? ' flip' : '');
    return (
      <div><center>
        <div className={className} onClick={this.flip.bind(this)}>
          <div className="flipper">
            <div className="front" style={{display: this.state.reveal ? 'none' : ''}}>
              {this.props.question}
            </div>
            <div className="back" style={{display: this.state.reveal ? '' : 'none'}}>
              {this.props.answer}
            </div>
          </div>
        </div>
        <button className="answerButton" onClick={this.flip.bind(this)}>flip</button>
      </center></div>
    );
  }
}

const Count = ({i, total}) =>
  <div>
    Question {i} / {total}
  </div>;


function updateSettings(e) {
  settings[e.target.getAttribute('id')] = e.target.checked;
  if (!settings.treble && !settings.bass && !settings.alto && !settings.tenor) {
    e.target.checked = true;
    settings[e.target.getAttribute('id')] = true;
    alert('Pick at least one clef');
  }
  if (!settings.major && !settings['natural minor'] && !settings['melodic minor'] && !settings['harmonic minor']) {
    e.target.checked = true;
    settings[e.target.getAttribute('id')] = true;
    alert('Pick at least one scale');
  }

  window.location.hash = Object.keys(settings).filter(s => settings[s] === true).join(',');
  if (window.location.hash.substring(1).split(',').length === Object.keys(settings).length) {
    // all the options = default
    window.location.hash = '';
  }

}

const Settings = ({init}) =>
  <table><tbody>
    <tr><th>Clefs</th><th>Scales</th></tr>
    <tr><td>
    {
      possibleCleffs.map(c => 
        <div key={c}>
          <input type="checkbox" id={c} defaultChecked={init[c]} onChange={updateSettings}/>
          <label htmlFor={c}>{c}</label>
        </div>
      )
    }
    </td><td>
    {
      Object.keys(intervals).map(s => 
        <div key={s}>
          <input type="checkbox" id={s} defaultChecked={init[s]} onChange={updateSettings}/>
          <label htmlFor={s}>{s}</label>
        </div>
      )
    }
    </td></tr>
  </tbody></table>;

export default App;
